import { IBreakpoint, IStyle } from "src/ScrollyInterface";

export const breakpoints = [
  {
    name: "desktopLg",
    query: window.matchMedia("(min-width: 2560px)")
  },
  {
    name: "desktopMd",
    query: window.matchMedia("(max-width: 2559px)")
  },
  {
    name: "desktopSm",
    query: window.matchMedia("(max-width: 1360px)")
  },
  {
    name: "tabletLg",
    query: window.matchMedia("(max-width: 1024px)")
  },
  {
    name: "tabletMd",
    query: window.matchMedia("(max-width: 900px)")
  },
  {
    name: "tabletSm",
    query: window.matchMedia("(max-width: 768px)")
  },
  {
    name: "mobileLg",
    query: window.matchMedia("(max-width: 600px)")
  },
  {
    name: "mobileMd",
    query: window.matchMedia("(max-width: 450px)")
  },
  {
    name: "mobileSm",
    query: window.matchMedia(
      "(orientation: portrait) and (max-height: 667px) and (max-width: 375px), (orientation: landscape) and (max-height: 414px) and (max-width: 823px)"
    )
  }
];

export const setStyles = (styleObj: IStyle, breakpoint: IBreakpoint) => {
  if (styleObj.default === undefined) {
    styleObj.default = "";
  }

  if (typeof breakpoint !== "object") {
    throw new Error(
      `Bad breakpoint type given: ${breakpoint} (${typeof breakpoint})`
    );
  }

  if (breakpoint.breakpointName === "default") {
    return styleObj.default;
  }
  const breakpointsArray: string[] = [];
  for (const bpoint of breakpoints) {
    breakpointsArray.push(bpoint.name);
  }
  breakpointsArray.reverse();

  const startingIndex = breakpointsArray.indexOf(breakpoint.breakpointName);

  const firstMatchedKey =
    breakpointsArray.slice(startingIndex).filter(key => styleObj[key])[0] ||
    "default";
  return styleObj[firstMatchedKey];
};

export const getParamSize = (param: string) => {
  const paramSize = param ? Number(param.substring(0, param.length - 2)) : 0;
  return paramSize;
};



// WEBPACK FOOTER //
// ./src/shared/breakpoints.tsx